import React from 'react';
import { Loading } from '../Loading';
import { FancyButton, FancyButtonProps } from './FancyButton';

type ConfirmButtonProps = Omit<FancyButtonProps, 'color' | 'background'> & {
  color?: string;
  background?: string;
};

export const ConfirmButton: React.FC<ConfirmButtonProps> = props => {
  const { loading, color, background, children } = props;
  return (
    <FancyButton {...props} color={color || 'white'} background={background || '#14c5b6'}>
      {loading ? <Loading color="white" size={45} /> : children}
    </FancyButton>
  );
};
